import { webUrl } from "@/views/general-hospital/utils/utils";
const _host = window.location.host;

/**
 * @description: 是否是本地或者测试环境
 * @return {Boolean}
 */
export function isLocalOrTest() {
  return (
    _host.includes("localhost:") ||
    _host.includes("192.168.")
  );
}

//防抖
export function debounce(fn, delay = 300) {
  let timer = null;
  return function() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay);
  };
}

//节流
export function throttle(fn, delay = 300) {
  let timer = null;
  return function() {
    if (timer) return;
    timer = setTimeout(() => {
      fn.apply(this, arguments);
      timer = null;
    }, delay);
  };
}
/**
 * @description: 当前是否是微信环境
 * @return {*} Boolean
 */
export const isWEIXIN = () => {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
};

//是否添加 webUrl
export const addWebUrl = url => {
  if (url.includes("http")) {
    return url;
  }
  return webUrl + url;
};

export const system = () => {
  const u = navigator.userAgent;
  let name;
  if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
    name = "android";
    // } else if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
  } else if (u.match(/iPhone|iPad|iPod/i)) {
    name = "ios";
  } else {
    name = "unknown";
  }
  return name;
};



// WEBPACK FOOTER //
// ./src/utils/publicMethods.js